module.exports = false;



//////////////////
// WEBPACK FOOTER
// /home/runner/work/slipresistant/slipresistant/client/~/babel-polyfill/~/core-js/modules/_library.js
// module id = 67TM
// module chunks = 0 3